import { useSelector } from 'react-redux'
import { userSelector } from '../../store/session'
import { useMemo } from 'react'

const useProtectedTableColumns = (columns) => {
  const { user } = useSelector(userSelector)
  const userRole = useMemo(() => user?.role?.type, [user])

  const filteredColumns = columns.filter((col) => !col.allowedRoles || col.allowedRoles.includes(userRole))
  return [filteredColumns]
}

export default useProtectedTableColumns
